import React from 'react';
import { NumberDirection } from  '@/interfaces/insightsp2';
import { BuildPath } from  '@/helpers/Paths';

const DirectionIcon = ({numberDirection} : {numberDirection:NumberDirection}) => {

    function iconURL():string {
        switch (numberDirection) {
            case NumberDirection.up:
                return "Assend.svg"           
            case NumberDirection.down:
                return "Decend.svg"   
            case NumberDirection.neutral:
                return "Neutral.svg"   
            case NumberDirection.new:
                return "NewRanking.svg"
            default:
                return ""
        }
    }

    if (iconURL() === ""){
        return null
    }

    return (
        <img data-testid="direction-icon" className={iconURL().split('.')[0]} src={`${BuildPath()}/images/insightsp2/${iconURL()}`} alt={""} />
    )
};

export default DirectionIcon;

